import { Icon } from '@iconify/react';
import ticketIcon from '@iconify/icons-mdi/ticket-confirmation';

const getIcon = (name) => <Icon icon={name} width={22} height={22} />;

const ticketSystemConfig = () => ({
  title: 'Sistema de Senhas',
  path: '/products/ticket-system',
  icon: getIcon(ticketIcon),
  children: [
    {
      title: 'Relatórios',
      path: '/products/ticket-system',
    },
    {
      title: 'Lojas',
      path: '/products/ticket-system/stores',
    },
  ],
});

export default ticketSystemConfig;